import { createFileRoute, notFound } from "@tanstack/react-router";

import { caseTagsQueries } from "@/api/resources/caseTags/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { CaseTagsPage } from "@/components/CaseTag/CaseTagsPage";
import i18n from "@/providers/i18n";
import { Icon } from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/tags/case-tags/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.tags-case-tags"),
        icon: <Icon.CASE_TAGS />,
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    await context.queryClient.ensureQueryData(caseTagsQueries.listAll());
  },
  component: CaseTagsPage,
});
